import Base from './Base'

export default class Flavor extends Base {
    type = 'flavor';
    
    toJSON = () => {
        let me = this, _this = {};
        ['_id', 'ref_id', 'type', 'parent', 'position', 'image', 'name', 'price', 'originalPrice', 'description', 'new', 'delete', 'show', 'extra_ingredients'].map((prop) => { _this[prop] = me[prop]; });
        return _this;
    }
}